import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Balance.css";

const Balance = () => {
    const { t } = useTranslation();
    
    document.title = t("Balance");

    return (
        <div className="balance-page-wrapper">
            <Container className="balance-content-container">
                <h1 className="balance-title">{t('Balance')}</h1>
                
                <div className="dev-badge-container">
                    <div className="dev-badge">
                        <div className="dev-badge-icon"></div>
                        <span className="dev-badge-text">
                            {t('This page is currently under development')}
                        </span>
                    </div>
                </div>

                <h3 className="tariffs-title">{t('Tariffs (Preview)')}</h3>
                
                <Row className="justify-content-center align-items-stretch">
                    <Col lg={4} md={6} className="mb-4">
                        <Card className="tariff-card">
                            <Card.Body className="d-flex flex-column text-center">
                                <Card.Title className="tariff-title">{t('Basic Plan')}</Card.Title>
                                <Card.Text className="tariff-desc flex-grow-1">
                                    {t('Perfect for getting started. Essential features included.')}
                                </Card.Text>
                                <div className="mt-4">
                                    <span className="tariff-price-placeholder">--</span>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    
                    <Col lg={4} md={6} className="mb-4">
                        <Card className="tariff-card pro">
                            <div className="tariff-popular-badge">
                                {t('MOST POPULAR')}
                            </div>
                            <Card.Body className="d-flex flex-column text-center mt-3">
                                <Card.Title className="tariff-title">{t('Pro Plan')}</Card.Title>
                                <Card.Text className="tariff-desc flex-grow-1">
                                    {t('Advanced features for active players and regular participants.')}
                                </Card.Text>
                                <div className="mt-4">
                                    <span className="tariff-price-placeholder">--</span>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    
                    <Col lg={4} md={6} className="mb-4">
                        <Card className="tariff-card">
                            <Card.Body className="d-flex flex-column text-center">
                                <Card.Title className="tariff-title">{t('Premium Plan')}</Card.Title>
                                <Card.Text className="tariff-desc flex-grow-1">
                                    {t('Maximum capabilities and premium support for professionals.')}
                                </Card.Text>
                                <div className="mt-4">
                                    <span className="tariff-price-placeholder">--</span>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Balance;
